import React from "react";

export const PageHeader = ({ title, eyebrow, action }) => (
  <div className="px-8 pt-10 pb-8 flex items-end justify-between">
    <div>
      {eyebrow && <div className="text-xs font-medium mb-1" style={{ color: "var(--accent)", letterSpacing: "-0.01em" }}>{eyebrow}</div>}
      <h1 className="text-3xl font-semibold" style={{ fontFamily: "var(--font-heading)", letterSpacing: "-0.03em", color: "var(--fg)" }}>{title}</h1>
    </div>
    {action}
  </div>
);

export const Metric = ({ label, value, sub, accent = "neutral", testid }) => {
  const color =
    accent === "profit" ? "var(--green)" :
    accent === "loss" ? "var(--loss)" :
    accent === "warn" ? "var(--green)" : "var(--fg)";
  return (
    <div
      className="p-5 transition-all hover:bg-white/[0.02]"
      style={{
        background: "var(--surface)",
        border: "1px solid var(--border)",
        borderRadius: "14px",
        backdropFilter: "blur(12px)",
      }}
      data-testid={testid}
    >
      <div className="text-xs font-medium mb-2" style={{ color: "var(--fg-3)", letterSpacing: "-0.01em" }}>{label}</div>
      <div className="text-2xl font-semibold" style={{ color, fontFamily: "var(--font-heading)", fontVariantNumeric: "tabular-nums", letterSpacing: "-0.02em" }}>{value}</div>
      {sub && <div className="text-xs mt-1" style={{ color: "var(--fg-3)" }}>{sub}</div>}
    </div>
  );
};

export const Card = ({ title, eyebrow, children, className = "", action }) => (
  <div
    className={`overflow-hidden ${className}`}
    style={{
      background: "var(--surface)",
      border: "1px solid var(--border)",
      borderRadius: "16px",
      backdropFilter: "blur(12px)",
    }}
  >
    {(title || eyebrow) && (
      <div className="flex items-center justify-between px-6 py-4" style={{ borderBottom: "1px solid var(--border)" }}>
        <div>
          {eyebrow && <div className="text-xs font-medium" style={{ color: "var(--accent)", letterSpacing: "-0.01em" }}>{eyebrow}</div>}
          {title && <div className="text-base mt-0.5 font-semibold" style={{ color: "var(--fg)", fontFamily: "var(--font-heading)", letterSpacing: "-0.02em" }}>{title}</div>}
        </div>
        {action}
      </div>
    )}
    <div className="p-6">{children}</div>
  </div>
);

export const Empty = ({ title, sub, action }) => (
  <div className="p-12 text-center" style={{ border: "1px dashed var(--border)", background: "var(--surface)", borderRadius: "16px" }}>
    <div className="text-xs font-medium" style={{ color: "var(--fg-3)" }}>No data yet</div>
    <div className="text-xl mt-3 font-semibold" style={{ color: "var(--fg)", fontFamily: "var(--font-heading)", letterSpacing: "-0.02em" }}>{title}</div>
    {sub && <div className="text-sm mt-2 max-w-md mx-auto" style={{ color: "var(--fg-2)" }}>{sub}</div>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);
